﻿import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    templateUrl: './admin-home.component.html'
})
export class AdminHomeComponent { }